<template>
    <div id="settings-page">
        <div class="container-fluid">
            <h1>{{ t('settings-plugins-title') }}</h1>
            <modal
                ref="addSender"
                :startsOpen="false"
                id="addSender"
                @hide="resetForm('')"
            >
                <template slot="title">
                    <span v-if="form.id"
                        >{{ t('settings-plugins-edit_sender', { name: rawEditing.title }) }}</span
                    >
                    <span v-else
                        >{{ t('settings-plugins-register_sender') }} <span v-lang="form.channel === 'tasks' ? 'tasks-label' : form.channel"></span
                    ></span>
                </template>
                <template slot="body">
                    <div>
                        <form @submit="saveSender()" ref="formSender">
                            <div class="field">
                                <input type="hidden" v-model="form.sender_id" />
                                <div class="senders-logos">
                                    <button
                                        v-for="sender in senderOptions"
                                        @click.prevent="
                                            form.sender_id = sender.id
                                        "
                                        :class="
                                            form.sender_id === sender.id
                                                ? 'selected'
                                                : ''
                                        "
                                        :disabled="
                                            sender.accepting_registration ===
                                            '0'
                                        "
                                        :key="sender.id"
                                    >
                                        <span
                                            class="badge badge-primary soon"
                                            v-if="
                                                sender.accepting_registration ===
                                                '0'
                                            "
                                            >{{ t('settings-plugins-soon') }}</span
                                        >
                                        <img
                                            :src="
                                                'images/senders/' +
                                                sender.name +
                                                '.png'
                                            "
                                            width="100%;"
                                        />
                                    </button>
                                </div>
                            </div>
                            <div
                                class="field"
                                v-if="
                                    form.sender_id &&
                                    form.id &&
                                    form.sender_id === rawEditing.senders_id
                                "
                            >
                                <div>
                                    <strong>{{ t('settings-plugins-monthly_value') }}:</strong> R${{
                                        rawEditing.sender_price
                                    }}
                                </div>
                                <div>
                                    <strong>{{ t('settings-plugins-cost_per_message') }}:</strong>
                                    {{ rawEditing.credits_cost }} {{ t('settings-plugins-credits') }}
                                </div>
                            </div>
                            <div
                                class="field"
                                v-else-if="form.sender_id && sender"
                            >
                                <div>
                                    <strong>{{ t('settings-plugins-monthly_value') }}:</strong> R${{
                                        sender.sender_price
                                    }}
                                </div>
                                <div>
                                    <strong>{{ t('settings-plugins-cost_per_message') }}:</strong>
                                    {{ sender.credits_cost }} {{ t('settings-plugins-credits') }}
                                </div>
                            </div>
                            <div class="field" v-if="form.sender_id">
                                <label>{{ t('title') }}</label>
                                <input
                                    v-model="form.alias"
                                    class="form-control"
                                    required
                                    type="text"
                                />
                            </div>
                            <div
                                class="field"
                                v-for="(field, index) in form_fields"
                                :key="index"
                            >
                                <label
                                    v-lang="'sender_options-' + field"
                                ></label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="form.form_fields[field]"
                                    required
                                />
                            </div>
                            <div class="field" v-if="form.sender_id">
                                <label>{{ t('settings-plugins-send_test_to') }}</label>

                                <input
                                    v-if="form.channel === 'email'"
                                    class="form-control"
                                    type="email"
                                    v-model="form.test"
                                    required
                                />
                                <input
                                    v-else
                                    type="text"
                                    class="form-control"
                                    v-model="form.test"
                                    required
                                />
                            </div>
                        </form>
                    </div>
                </template>
                <template slot="footer">
                    <div>
                        <button
                            type="button"
                            class="btn btn-cancel"
                            @click.prevent="resetForm('')"
                        >
                            {{ t('cancel') }}
                        </button>
                        <button
                            type="button"
                            class="btn btn-success"
                            @click.prevent="save()"
                        >
                            <span v-if="form.id"> {{ t('settings-plugins-save_changes') }} </span>
                            <span v-else> {{ t('settings-plugins-add_sender') }} </span>
                        </button>
                    </div>
                </template>
            </modal>
            <div class="row mt-4">
                <div class="col-12">
                    <div class="box">
                        <div class="top">
                            <h2>{{ t('sms') }}</h2>
                            <button
                                @click="resetForm('sms')"
                                class="btn btn-small btn-primary"
                            >
                                {{ t('add') }}
                            </button>
                        </div>
                        <plugin-list :senders="smsSenders" @edit="edit" />
                    </div>
                </div>
            </div>
            <div class="row mt-4" v-if="$module('rcs')">
                <div class="col-12">
                    <div class="box">
                        <div class="top">
                            <h2>{{ t('rcs') }}</h2>
                            <button
                                @click="resetForm('rcs')"
                                class="btn btn-small btn-primary"
                            >
                                {{ t('add') }}
                            </button>
                        </div>
                        <plugin-list :senders="rcsSenders" @edit="edit" />
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-12">
                    <div class="box">
                        <div class="top">
                            <h2>{{ t('email') }}</h2>
                            <button
                                @click="resetForm('email')"
                                class="btn btn-small btn-primary"
                            >
                                {{ t('add') }}
                            </button>
                        </div>
                        <plugin-list :senders="emailSenders" @edit="edit" />
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-12">
                    <div class="box">
                        <div class="top">
                            <h2>{{ t('whatsapp_official') }}</h2>
                            <button
                                @click="resetForm('whatsapp-cloud')"
                                class="btn btn-small btn-primary"
                            >
                                {{ t('add') }}
                            </button>
                        </div>
                        <plugin-list :senders="wppCloudSenders" @edit="edit" />
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-12">
                    <div class="box">
                        <div class="top">
                            <h2>{{ t('whatsapp') }}</h2>
                            <button
                                @click="resetForm('whatsapp')"
                                class="btn btn-small btn-primary"
                            >
                                {{ t('add') }}
                            </button>
                        </div>
                        <plugin-list :senders="wppSenders" @edit="edit" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
form .field {
    margin-bottom: 20px;
}
.senders-logos {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    grid-gap: 20px;
    button {
        border: 4px solid transparent;
        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
            &.selected {
                border: 4px solid var(--primary);
            }
        }
        &:not(:disabled) {
            cursor: pointer;
            &.selected,
            &:hover {
                border: 4px solid var(--primary);
            }
        }
    }
}
.top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
    h2 {
        margin-bottom: 0;
    }
}
</style>
<script>
import keviApi from "../../keviApi";
import Modal from "../../components/modal/modal";
import PluginList from "./pluginList";
import Import from "../../clients/import";
export default {
    components: { Import, Modal, PluginList },
    data() {
        return {
            senders: [],
            my_senders: [],
            form_fields: [],
            rawEditing: {
                title: null,
                sender_price: null,
                credits_cost: null,
                senders_id: null,
            },
            form: {
                id: null,
                alias: null,
                test: null,
                channel: null,
                sender_id: null,
                form_fields: {},
            },
        };
    },
    computed: {
        isValid() {
            if (!this.form.channel || !this.form.sender_id || !this.form.test) {
                return false;
            }
            for (let f in this.form.form_fields) {
                if (!this.form.form_fields[f]) {
                    return false;
                }
            }
            return true;
        },
        emailSenders() {
            return this.my_senders.filter((s) => s.channel === "email");
        },
        smsSenders() {
            return this.my_senders.filter((s) => s.channel === "sms");
        },
        rcsSenders() {
            return this.my_senders.filter((s) => s.channel === "rcs");
        },
        wppSenders() {
            return this.my_senders.filter((s) => s.channel === "whatsapp");
        },
        wppCloudSenders() {
            return this.my_senders.filter(
                (s) => s.channel === "whatsapp-cloud",
            );
        },
        sender() {
            return this.senders.find((s) => s.id === this.form.sender_id);
        },
        senderOptions() {
            if (!this.form.channel) {
                return [];
            }
            return this.senders.filter((s) => s.channel === this.form.channel);
        },
    },
    async mounted() {
        await this.loadSenders();
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        save() {
            if (this.$refs.formSender.checkValidity()) {
                this.saveSender();
                this.resetForm();
            } else {
                this.$refs.formSender.reportValidity();
            }
        },
        edit(sender) {
            this.rawEditing = sender;
            this.form = {
                id: sender.id,
                alias: sender.alias,
                test: null,
                channel: sender.channel,
                sender_id: sender.senders_id,
                form_fields: {},
            };
            for (let f in sender.fields) {
                this.$set(this.form.form_fields, f, sender.fields[f]);
            }
            this.$refs.addSender.open();
        },
        resetForm(channel = null) {
            if (channel) {
                this.$refs.addSender.open();
            } else {
                this.$refs.addSender.close();
            }
            this.rawEditing = {
                title: null,
                sender_price: null,
                credits_cost: null,
            };
            this.form_fields = [];
            this.form = {
                id: null,
                alias: null,
                test: null,
                channel,
                sender_id: null,
                form_fields: {},
            };
        },
        async loadSenders() {
            let options = keviApi.getOptions("/senders", "GET");
            const response = await this.$http(options);
            this.senders = response.body.available_integrations;
            this.my_senders = response.body.my_senders;
        },
        async saveSender() {
            let options = keviApi.getOptions(
                "/senders/save",
                "POST",
                JSON.parse(JSON.stringify(this.form)),
            );
            try {
                await this.$http(options);
                this.loadSenders();
                this.$store.dispatch(
                    "notification/success",
                    this.t('settings-plugins-sender_saved_test_sent'),
                );
            } catch (err) {
                this.$store.dispatch(
                    "notification/warning",
                    this.t("error") + ": " + (err.body.test_error || this.t("unknown")),
                );
            }
        },
    },
    watch: {
        "form.sender_id": function () {
            const sender = this.senders.find(
                (s) => s.id == this.form.sender_id,
            );
            this.form.test = null;
            this.form_fields = sender.fields ? [...sender.fields] : [];
            this.form.form_fields = {};
            let editting = {};
            if (this.form.id) {
                editting = this.my_senders.find((s) => s.id === this.form.id);
                if (editting) {
                    editting = editting.fields;
                }
            }
            this.form_fields.forEach((field) => {
                this.$set(this.form.form_fields, field, editting[field] || "");
            });
        },
    },
};
</script>
